import script from "./Wikis.vue?vue&type=script&setup=true&lang=js"
export * from "./Wikis.vue?vue&type=script&setup=true&lang=js"

import "./Wikis.vue?vue&type=style&index=0&id=0e32cec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_da608881a56338d32c19221dd8f0283b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e32cec2"]])

export default __exports__